import { useEffect } from "react";
import { useObservable } from "micro-observables";
import { useSelector } from "react-redux";

import {
    activeDataSelector,
    currentBlockSelector,
    currentIframe,
    iframeList,
    requestNormalizersByUrls,
    tabIndex
} from "../services/stepThree";
import highlightElement from "../../utils/highlightElement";
import iFrameCssClasses from "../../constants/iFrameCssClasses";
import clearCssClassName from "../../utils/clearCssClassName";
import getElementByXpath from "../../utils/getElementByXpath";
import { httpResponseSelector } from "../../../services/general/selectors";

const useHighlightElements = () => {
    const response = useSelector(httpResponseSelector);
    const dataSelector = useObservable(activeDataSelector);
    const blockSelector = useObservable(currentBlockSelector);
    const iframe = useObservable(currentIframe);
    const iframes = useObservable(iframeList);
    const index = useObservable(tabIndex);

    useEffect(
        () => {
            clearCssClassName(iframe, iFrameCssClasses.visible);

            if(blockSelector.data_selectors.length !== 0) {
                const xPaths = blockSelector.data_selectors.reduce(
                    (acc, item) => {
                        if(item.type_code === "XPATH") {
                            acc.push(...item.selectors.map(({ selector }) => selector.replace("/@href", "")));
                        }

                        return acc;
                    },
                    []
                );

                setTimeout(
                    () => {
                        highlightElement(iframe, xPaths, iFrameCssClasses.visible);
                    },
                    200
                );
            }
        },
        [ blockSelector, iframe ]
    );

    useEffect(
        () => {
            const iframe = iframes[index];

            if(!dataSelector) {
                clearCssClassName(iframe, iFrameCssClasses.active);

                return;
            }

            const identifiers = dataSelector.selectors.map(({ selector }) => ({ xPath: selector.replace("/@href", "") }));
            const hrefs = [];
            const xPaths = identifiers.map(({ xPath }) => xPath);
            let elements = getElementByXpath(iframe, xPaths);

            elements.forEach((element) => {
                const href = element.getAttribute("href");

                if(href) {
                    hrefs.push(href);
                }
            });

            if(hrefs.length !== 0) {
                setTimeout(
                    () => {
                        requestNormalizersByUrls({
                            hrefs,
                            isMultiple: dataSelector?.is_multiple,
                            scrapeTaskUrl: response[index].url,
                            normalizers: dataSelector.normalizers
                        });
                    },
                    20
                );
            }

            highlightElement(iframe, xPaths, iFrameCssClasses.active);
        },
        [ iframes, response, index, dataSelector ]
    );
};

export default useHighlightElements;
